import loadash from 'lodash';
window._ = loadash;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';
import {
  clearJwtLocalSession,
  persistJwtFromApiResponse,
  readJwtFromLocalSession,
} from './shared/lib/localSession';
import Snotify from 'vue-snotify';
import BootstrapVue from 'bootstrap-vue';
import VueTheMask from 'vue-the-mask';
import money from 'v-money';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Multiselect from 'vue-multiselect'
import Spinner from 'vue-simple-spinner'
import Simplert from 'vue2-simplert-plugin';
import Admin from './layout/Admin.vue';
import Login from './layout/Login.vue';
require('vue2-simplert-plugin/dist/vue2-simplert-plugin.css')
import VueTour from 'vue-tour';
require('vue-tour/dist/vue-tour.css')
import Form from './Form';
import FileForm from './FileForm';
import Errors from './Errors';
import VCalendar from 'v-calendar';
import ReturnApi from './ReturnApi';
import Navbar from './components/Navbar';
import Breadcrumb from './components/Breadcrumb';
import Promise from 'promise-polyfill';

if (!window.Promise) {
  window.Promise = Promise
}
window.Form = Form;
window.FileForm = FileForm
window.Errors = Errors;
window.ReturnApi = ReturnApi;

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(Snotify);
Vue.use(Simplert);
Vue.use(Spinner);
Vue.use(Navbar);
Vue.use(Breadcrumb);
Vue.use(Multiselect);
Vue.use(VueTheMask);
Vue.use(money);
Vue.use(Login);
Vue.use(VCalendar, {
  locales: {
    'pt-BR': {
      firstDayOfWeek: 1,
      masks: {
        L: 'DD/MM/YYYY',
        // ...optional `title`, `weekdays`, `navMonths`, etc
      }
    }
  }
});
Vue.use(VueTour);
Vue.component('Admin', Admin);
Vue.component('Login', Login);
Vue.component('Navbar', Navbar);
Vue.component('Breadcrumb', Breadcrumb);
Vue.component('spinner', Spinner);
Vue.component('Multiselect', Multiselect);
Vue.component('Snotify', Snotify);
Vue.component('Simplert', Simplert);

window.Vue = Vue;
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.withCredentials = true;

axios.interceptors.request.use((config) => {
  const token = readJwtFromLocalSession();
  if (token) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization && !config.headers.authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

axios.interceptors.response.use((response) => {
  if (response && response.data) {
    persistJwtFromApiResponse(response.data);
  }
  return response;
});

window.clearJwtLocalSession = clearJwtLocalSession;
